<oui-autocomplete
  #consultantAutocomplete
  [label]="label"
  [control]="consultantControl"
  [options]="consultantAutocompleteOptions"
  [allowCustomValue]="true"
  [displayOptionsOnEmptySearch]="false"
  [displayResetButton]="true"
  [isLoading]="isConsultantLoading"
  class="width-100pc"></oui-autocomplete>
